// Zdieľaný „popis v ráme" — rovnaký vzhľad popisu v detaile NÁVYKU aj VÝZVY/SÚŤAŽE.
// Text = .bz-aitext (čitateľný tmavý), rám = .bz-descrbox (jemné pozadie + orámovanie).
export function DescrBox({ text, style }) {
  if (!text) return null;
  return <div className="bz-aitext bz-descrbox" style={style}>{text}</div>;
}
